module.exports = __webpack_public_path__ + "static/media/sliderimg4.06045d86.png";